<template>
  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 6.5L6.5 3.5L3.5 0.5L3.09538 0.908853L5.40042 3.21389H0.5V3.78611H5.40042L3.09538 6.09115L3.5 6.5Z" fill="#888888"/>
  </svg>
</template>